import React from 'react'

import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import { usePresentationNav } from '../../PresentationNav'

import QuoteComponent from '../../../Quote/Quote'
import QuotePlaceholder from './QuotePlaceholder'
import AnimationWrapper from '../../util/AnimationWrapper'

import ButtonBlock from '../Button/ButtonBlock'

function QuoteBlock(props: PresentationBlockProps) {
  const { isQuoteEmpty } = usePresentationNav()
  if (isQuoteEmpty) return null
  const { WrapperComponent, isSettings, block, useCart, objectLabels } = props

  const animation = block.fields?.animation

  if (useCart) {
    return <ButtonBlock cartLink={true} {...props} />
  } else
    return (
      <>
        <WrapperComponent {...props}>
          <AnimationWrapper animation={animation} index={0} direction={'top'}>
            <div>
              {isSettings ? <QuotePlaceholder objectLabels={objectLabels} /> : <QuoteComponent inPresentation={true} />}
            </div>
          </AnimationWrapper>
        </WrapperComponent>
      </>
    )
}

export default React.memo(QuoteBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
